import { HttpHandler } from 'shared/httpHandler';

const LEXUS_LIFF_REURL_URL = process.env.REACT_APP_LEXUS_LIFF_ID_REURL
  ? `https://liff.line.me/${process.env.REACT_APP_LEXUS_LIFF_ID_REURL}`
  : 'http://localhost:3000';
const httpHandler = new HttpHandler();

const BASE_URL = `${
  process.env.REACT_APP_BASE_URL || 'http://localhost:8000'
}/dashboard/campaign_maintenance`;

function toBase64(str) {
  const utf8Bytes = new TextEncoder().encode(str);
  const binary = String.fromCharCode(...utf8Bytes);
  return btoa(binary);
}

const getCampaignData = async (params) => {
  const queryParams = new URLSearchParams();
  try {
    Object.entries(params).forEach(([key, value]) => {
      queryParams.append(key, value);
    });
  } catch (error) {
    console.error('Error constructing query parameters:', error);
    throw new Error('Failed to construct query parameters');
  }

  const response = await httpHandler.get(
    `${BASE_URL}/get_campaign_references?${queryParams.toString()}`
  );

  return response;
};

const createCampaign = async (data) => {
  const response = await httpHandler.post(
    `${BASE_URL}/create_campaign_reference`,
    { ...data, url: btoa(data.url), name: toBase64(data.name) }
  );
  return response;
};

const updateCampaign = async (data) => {
  const response = await httpHandler.put(
    `${BASE_URL}/update_campaign_reference/${data.id}`,
    { ...data, url: btoa(data.url), name: toBase64(data.name) }
  );
  return response;
};

const deleteCampaign = async (id) => {
  const response = await httpHandler.delete(
    `${BASE_URL}/delete_campaign_reference/${id}`
  );
  return response;
};

export const combineCampaignReUrl = (data) => {
  const { url, tags, signature } = data;
  const tagParams = tags
    .map((tag) => `tag=${encodeURIComponent(tag)}`)
    .join('&');
  const combinedUrl = `${LEXUS_LIFF_REURL_URL}/campaign?redirectUrl=${encodeURIComponent(
    btoa(url)
  )}&${tagParams}&signature=${encodeURIComponent(signature)}`;

  return combinedUrl;
};

export const getHotaiTags = async () => {
  const response = await httpHandler.get(
    `${process.env.REACT_APP_BASE_URL}/webview/lexus/tags`
  );
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getCampaignData,
  createCampaign,
  updateCampaign,
  deleteCampaign,
  getHotaiTags,
};
